import { cloudinaryUrl } from "@gigpro/utils";
import { env } from "config/env";

export const getCloudinaryImage = (
  publicId: string,
  options?: { width?: number; height?: number; circle?: boolean },
) => ({
  toURL: () =>
    cloudinaryUrl(env.REACT_APP_CLOUDINARY_CLOUD_NAME, publicId, options && { ...options, progressive: true }),
});

export const uploadImage = async (file: File): Promise<{ public_id: string }> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "location_images");
  const response = await fetch(`https://api.cloudinary.com/v1_1/${env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`, {
    method: "POST",
    body: formData,
  });
  const data = await response.json();
  return data;
};

export const makeIdToCloudinaryUrl = (image_public_id: string | undefined | null) =>
  image_public_id ? getCloudinaryImage(image_public_id, { circle: true, width: 100, height: 100 }).toURL() : undefined;

export const defaultImage = makeIdToCloudinaryUrl(env.REACT_APP_DEFAULT_LOCATION_IMAGE_ID);
